import { Container, Flex, Stack, Title } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { UserSetupForm } from '@/module/Setup/UserSetupForm';
import { useSetupAccount } from '@/module/Setup/model/SetupQuery';
import { SetupSchema, defaultSetupValues, setupSchema } from '@/module/Setup/model/SetupSchema';

import { useAppNotification } from '@feature/utils';

export function UserSetup() {
  const { t } = useTranslation();
  const { mutate, isError, isSuccess, isPending } = useSetupAccount();

  const notification = useAppNotification();
  const navigate = useNavigate();
  const onSubmit = (values: SetupSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: () => {
        notification.success();
        navigate({ to: '/' });
      },
    });
  };

  return (
    <Container
      w="100%"
      h="100vh"
    >
      <Flex
        justify="center"
        align="center"
        h="100%"
      >
        <Stack miw="400px">
          <Title ta="center">{t('setup.title')}</Title>
          <UserSetupForm
            onSubmit={onSubmit}
            onCancel={undefined}
            defaultValues={defaultSetupValues}
            values={undefined}
            schema={setupSchema}
            isError={isError}
            isSuccess={isSuccess}
            isSubmitting={isPending}
          />
        </Stack>
      </Flex>
    </Container>
  );
}
